import apiClient from "../helpers/apiClient";
const API_RESTO_HOST = `/api/v2/chat`
const api = apiClient();

export const getMessageHost = () => api.get(`${API_RESTO_HOST}/messages/host`);
export const sendMessageChat = (data) => api.post(`${API_RESTO_HOST}/send-message`, data);
export const sendGlobalMessageChat = (data) => api.post(`${API_RESTO_HOST}/fgs/send-message`, data);
export const markMessage = (id) => api.get(`${API_RESTO_HOST}/markmessage/${id}`);
